import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  Allegati,
  Environment,
  IAllegatiAttivitaModel,
  IAllegatoMacchinaModel,
  IsErrorValues,
  ModelNumStr,
  IAllegatiRenderModel,
  IAllegatiTicketsModel,
  IAllegatiSchedeInterventoModel,
  AllegatiMagazziniRdAModel,
  AllegatiArticoliModel,
} from '../../models/-index';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class AllegatiService extends CrudGenericsService<Allegati, number> {
  private base: string;
  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Allegati`);
    this.base = `${env.apiUrl}/api/Allegati/`;
  }
  // get allegati per tabelle molti a molti
  // ........... macchine .............
  // get allegati metodo generico, modello Allegati con navigazione Gruppi
  GetAllegati_ByPostazioneOrMacchinaOrComponente(pos: number = 0, mac: number = 0, com: number = 0): Observable<Allegati[]> {
    const u = this.base + 'GetAllegati_ByPostazioneOrMacchinaOrComponente?pos=' + pos + '&mac=' + mac + '&com=' + com;
    return this.http.get<Allegati[]>(`${u}`);
  }

  // obsoleta usare il metodo sopra
  /*
  Get_AllegatiMacchinePostazione(postazione: number = 0): Observable<Allegati[]> {
    const u = this.base + 'Get_AllegatiMacchinePostazione?pos=' + postazione;
    return this.http.get<Allegati[]>(`${u}`);
  }
*/

  // get allegati metodo light per ionic modello IAllegatiRenderModel con DesGruppo
  GetAllegatiRenderModel_ByPosOrMacOrCom(
    pos: number = 0,
    mac: number = 0,
    com: number = 0
  ): Observable<IAllegatiRenderModel[]> {
    const u = this.base + 'GetAllegatiRenderModel_ByPosOrMacOrCom?pos=' + pos + '&mac=' + mac + '&com=' + com;
    return this.http.get<IAllegatiRenderModel[]>(`${u}`);
  }
  Add_AllegatoMacchinaModel(model: IAllegatoMacchinaModel): Observable<IsErrorValues> {
    const u = this.base + 'Add_AllegatoMacchinaModel';
    return this.http.post<IsErrorValues>(`${u}`, model);
  }

  Remove_AllegatoMacchina(alle: number) {
    const u = this.base + 'Remove_AllegatoMacchina/' + alle;
    return this.http.delete(`${u}`);
  }
  // .......fine macchine .............

  // ........... procedure attivita .............

  Get_AttivitaAllegati(attivita: number): Observable<Allegati[]> {
    const u = this.base + 'Get_AttivitaAllegati?attivita=' + attivita;
    return this.http.get<Allegati[]>(`${u}`);
  }

  Add_AttivitaAllegatiModel(model: IAllegatiAttivitaModel): Observable<IsErrorValues> {
    const u = this.base + 'Add_AttivitaAllegatiModel';
    return this.http.post<IsErrorValues>(`${u}`, model);
  }
  // by sllegato
  Remove_AttivitaAllegati(alle: number) {
    const u = `${this.base}Remove_AttivitaAllegati?alle=${alle}`;
    return this.http.delete(`${u}`);
  }
  // .......fine attivita  .............

  // ........ magazzini rda ......... //
  Add_MagazziniRdaAllegatiModel(model: AllegatiMagazziniRdAModel): Observable<IsErrorValues> {
    const u = `${this.base}Add_MagazziniRdaAllegatiModel`;
    return this.http.post<IsErrorValues>(u, model);
  }

  Get_MagazziniRdaAllegati(id: number): Observable<Allegati[]> {
    const u = `${this.base}Get_MagazziniRdaAllegati?id=${id}`;
    return this.http.get<any[]>(u);
  }
  // .......fine magazzini rda ............. //

  // ........ Articoli ......... //
  Add_ArticoliAllegati_ByModel(model: AllegatiArticoliModel): Observable<IsErrorValues> {
    const u = `${this.base}Add_ArticoliAllegati_ByModel`;
    return this.http.post<IsErrorValues>(u, model);
  }

  Get_ArticoliAllegati_ByIdArticolo(id: number): Observable<Allegati[]> {
    const u = `${this.base}Get_ArticoliAllegati_ByIdArticolo?id=${id}`;
    return this.http.get<any[]>(u);
  }

  Remove_ArticoliAllegati_ByIdAllegato(id: number) {
    const u = `${this.base}Remove_ArticoliAllegati_ByIdAllegato?id=${id}`;
    return this.http.delete(u);
  }
  // .......fine Articoli ............. //

  // ---------- rendering thumbinals cambio categoria -----
  UpdAllegatoIdCategoria_ByModelNumStr(path_allegato: string, id_categoria: number): Observable<ModelNumStr> {
    const model: ModelNumStr = {
      Value: id_categoria,
      Text: path_allegato,
    };
    const u = this.base + 'UpdAllegatoIdCategoria_ByModelNumStr';
    return this.http.post<any>(`${u}`, model);
  }

  // ================================= //
  // ============== IONIC ============ //
  // ............ inizio tickets ............ (ionic)

  Add_TicketsAllegatiModel(model: IAllegatiTicketsModel[]): Observable<IsErrorValues[]> {
    const u = this.base + 'Add_TicketsAllegatiModel';
    return this.http.post<IsErrorValues[]>(`${u}`, model);
  }
  GetAllegatiRenderModel_ByIdTicket(id: number): Observable<IAllegatiRenderModel[]> {
    const u = this.base + 'GetAllegatiRenderModel_ByIdTicket?id=' + id;
    return this.http.get<IAllegatiRenderModel[]>(`${u}`);
  }
  // ........... fine tickets ...............

  // ............ inizio schede intervento ............ (ionic)
  // and web form
  Add_AllegatiSchedeInterventoModel(model: IAllegatiSchedeInterventoModel[]): Observable<IsErrorValues[]> {
    const u = this.base + 'Add_AllegatiSchedeInterventoModel';
    return this.http.post<IsErrorValues[]>(`${u}`, model);
  }
  GetAllegatiRenderModel_BySchedaIntervento(id: number): Observable<IAllegatiRenderModel[]> {
    const u = this.base + 'GetAllegatiRenderModel_BySchedaIntervento?id=' + id;
    return this.http.get<IAllegatiRenderModel[]>(`${u}`);
  }
}
